var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c(
      "div",
      { staticClass: "modal-dialog modal-xs", attrs: { role: "document" } },
      [
        _vm.state.selectedBoard
          ? _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.$t("kanban.approval.requestModal.title")))
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.dismiss.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("×")]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("kanban.approval.requestModal.assignee")) +
                      "\n        "
                  ),
                  _c("vSelect", {
                    attrs: {
                      options: _vm.availableApprovers,
                      label: "name",
                      reduce: t => t.id,
                      clearable: false
                    },
                    model: {
                      value: _vm.assignee,
                      callback: function($$v) {
                        _vm.assignee = $$v
                      },
                      expression: "assignee"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    on: { click: _vm.dismiss }
                  },
                  [_vm._v(_vm._s(_vm.$t("btnCancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { disabled: !_vm.canSave || _vm.saving },
                    on: { click: _vm.save }
                  },
                  [
                    _vm.saving
                      ? _c("Spinner", { attrs: { small: true } })
                      : _vm._e(),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("kanban.approval.requestModal.requestApproval")
                        ) +
                        "\n        "
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }